import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';

export const PROJECT_ID = process.env.REACT_APP_FIREBASE_PROJECT_ID  || 'dummy-project-id';

initializeApp({
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'dummy-api-key',
    authDomain: `${PROJECT_ID}.firebaseapp.com`,
    databaseURL: `https://${PROJECT_ID}.firebaseio.com`,
    projectId: PROJECT_ID,
    storageBucket: `${PROJECT_ID}.appspot.com`,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || 'sender-id',
    appId: process.env.REACT_APP_FIREBASE_APP_ID  || 'app-id'
});

export const auth = getAuth();

const isEmulator = process.env.REACT_APP_IS_FIREBASE_EMULATOR === 'true' ? true : false;
if (isEmulator) {
    connectAuthEmulator(auth, 'http://localhost:9099');
}

export const analytics = !isEmulator && getAnalytics();
